import React, { useState, useEffect } from 'react';
import { Typography, Box, TextField, Button, Alert, MenuItem } from '@mui/material';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3'; // Use v3
import { firestore } from '../firebase';
import { collection, addDoc } from 'firebase/firestore';

const ContactInner = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    reason: '',
    messageAnswer: '',
    website: 'API Documentation Website', 
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { executeRecaptcha } = useGoogleReCaptcha();


  useEffect(() => {
    if (!executeRecaptcha) {
      console.log('reCAPTCHA not yet available');
    }
  }, [executeRecaptcha]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: '', message: '' });
    setIsSubmitting(true);

    if (!executeRecaptcha) {
      setStatus({ type: 'error', message: 'reCAPTCHA is not available. Please refresh the page.' });
      setIsSubmitting(false);
      return;
    }

    try {
      const recaptchaToken = await executeRecaptcha('contactForm'); // Action name for analytics
      if (!recaptchaToken) {
        setStatus({ type: 'error', message: 'reCAPTCHA verification failed. Please try again.' });
        setIsSubmitting(false);
        return;
      }

      await addDoc(collection(firestore, 'contactUs'), {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        reason: formData.reason,
        messageAnswer: formData.messageAnswer,
        website: formData.website, 
        timestamp: new Date(),

      });

      setStatus({ type: 'success', message: 'Your message has been sent successfully!' });
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        reason: '',
        messageAnswer: '',
        website: 'API Documentation Website',
      });
    } catch (error) {
      console.error('Error adding document: ', error);
      setStatus({ type: 'error', message: 'Error submitting your message. Please try again.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', textAlign: 'center' }}>
      <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 2 }}>
        Contact Us
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        Have questions about the OSINT API Platform? Fill out the form below to reach out to us!
      </Typography>

      <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <TextField
            label="First Name"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
            fullWidth
            variant="outlined"
          />
          <TextField
            label="Last Name"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            required
            fullWidth
            variant="outlined"
          />
        </Box>
        <TextField
          label="Email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          required
          fullWidth
          variant="outlined"
        />
        <TextField
          label="Reason for Contacting"
          name="reason"
          value={formData.reason}
          onChange={handleChange}
          required
          fullWidth
          variant="outlined"
          select
        >
          <MenuItem value="">Please select a reason</MenuItem>
          <MenuItem value="inquiry">General Inquiry</MenuItem>
          <MenuItem value="feedback">Feedback & Suggestions</MenuItem>
          <MenuItem value="issue">Report an Issue / Bug</MenuItem>
          <MenuItem value="billing">Billing & Payments</MenuItem>
          <MenuItem value="technicalSupport">Technical Support</MenuItem>
          <MenuItem value="api">API Questions</MenuItem>
          <MenuItem value="partnership">Partnership / Collaboration</MenuItem>
          <MenuItem value="other">Other</MenuItem>
        </TextField>
        <TextField
          label="Message"
          name="messageAnswer"
          value={formData.messageAnswer}
          onChange={handleChange}
          required
          fullWidth
          variant="outlined"
          multiline
          rows={4}
        />

        <input type="hidden" name="website" value={formData.website} />
        <Button
          style={{ height: 50, borderRadius: 8 }}
          type="submit"
          variant="contained"
          fullWidth
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : 'Send Message'}
        </Button>
      </Box>

      {status.message && (
        <Alert severity={status.type} sx={{ mt: 2 }}>
          {status.message}
        </Alert>
      )}

      <Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
        Email: support@arclighttech.com<br />
        Phone: +1 813 808 3984<br />
        Address: Tampa, FL 33626, USA
      </Typography>
    </Box>
  );
};

const Contact = () => (
  <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_CAPTCHA_SITE_KEY || ''}>
    <ContactInner />
  </GoogleReCaptchaProvider>
);

export default Contact;